const AbstractDialog = require("common/AbstractDialog");
const Utils = require("common/Utils");

function CreateFolderDialog() {
    AbstractDialog.call(this);

    const self = this;

    var targetPath;

    const $content = this.getContent();
    $content.attr("id", "createFolderDialog")
        .append($(require("html!./create_folder_dialog_content.html")));

    const nameInput = $content.find("input");
    const createButton = $content.find("#createFolderButton");
    const errorLabel = $content.find("span.errorMessage");

    this.setTitle($.t("common::vfs.createFolder.title"));

    this.setPath = function(path) {
        targetPath = path;
    };

    function submit() {
        errorLabel.hide();

        self.publishEvent("VFSController", "create-folder", {
            target : targetPath,
            name : nameInput.val()
        });
    }

    Utils.registerKeyboardSubmit(nameInput, submit);
    createButton.on("click", submit);

    this.show = function() {
        errorLabel.text("");
        errorLabel.hide();
        nameInput.val("");
        nameInput.trigger("focus");

        this.setEnabled(true);
    };

    this.setErrorMessage = function(message) {
        errorLabel.text(message);
        errorLabel.show();
    };

    this.setEnabled = function(val) {
        Utils.setElementEnabled(createButton, val);
        Utils.setElementEnabled(nameInput, val);
        Utils.setElementEnabled($content.find("a.ui-icon-mobile-close"), val);
    };
}

Utils.inherits(CreateFolderDialog, AbstractDialog);

module.exports = CreateFolderDialog;